<h3>{{ idEnModification !== null ? ('admin.ev.modifierTitre' | traduire) : ('admin.ev.ajouter' | traduire) }}</h3>

<form class="form-ajout" (ngSubmit)="validerFormulaire()">

  <label>{{ 'admin.ev.titreDescLangue' | traduire }}</label>
  <div class="lang-tabs">
    <button type="button" class="lang-tab" [class.actif]="true" onclick="return false;">🇫🇷 FR</button>
  </div>
  <input type="text" [(ngModel)]="formEvenement.titre" name="titre" [placeholder]="'admin.ev.titreFr' | traduire" required>
  <textarea [(ngModel)]="formEvenement.description" name="description" rows="2" [placeholder]="'admin.ev.descFr' | traduire" style="margin-top:8px;"></textarea>

  <div class="ligne" style="margin-top:14px;">
    <div>
      <label>🇬🇧 {{ 'admin.ev.titreEn' | traduire }}</label>
      <input type="text" [(ngModel)]="formEvenement.titreEn" name="titreEn">
    </div>
    <div>
      <label>🇹🇳 {{ 'admin.ev.titreAr' | traduire }}</label>
      <input type="text" [(ngModel)]="formEvenement.titreAr" name="titreAr" dir="rtl">
    </div>
  </div>
  <div class="ligne">
    <div>
      <label>🇬🇧 {{ 'admin.ev.descEn' | traduire }}</label>
      <textarea [(ngModel)]="formEvenement.descriptionEn" name="descriptionEn" rows="2"></textarea>
    </div>
    <div>
      <label>🇹🇳 {{ 'admin.ev.descAr' | traduire }}</label>
      <textarea [(ngModel)]="formEvenement.descriptionAr" name="descriptionAr" rows="2" dir="rtl"></textarea>
    </div>
  </div>

  <div class="ligne" style="margin-top:14px;">
    <div>
      <label>{{ 'admin.ev.categorie' | traduire }}</label>
      <select [(ngModel)]="formEvenement.categorie" name="categorie">
        <option value="Musique">{{ 'admin.ev.catMusique' | traduire }}</option>
        <option value="Théâtre">{{ 'admin.ev.catTheatre' | traduire }}</option>
        <option value="Danse">{{ 'admin.ev.catDanse' | traduire }}</option>
        <option value="Cinéma">{{ 'admin.ev.catCinema' | traduire }}</option>
      </select>
    </div>
    <div>
      <label>{{ 'admin.ev.lieu' | traduire }}</label>
      <input type="text" [(ngModel)]="formEvenement.lieu" name="lieu">
    </div>
  </div>

  <div class="ligne">
    <div>
      <label>{{ 'admin.ev.date' | traduire }}</label>
      <input type="date" [(ngModel)]="formEvenement.dateEvent" name="dateEvent">
    </div>
    <div>
      <label>{{ 'admin.ev.prix' | traduire }}</label>
      <input type="number" [(ngModel)]="formEvenement.prix" name="prix">
    </div>
  </div>

  <app-photo-uploader [label]="'admin.ev.imageEvenement' | traduire" [value]="formEvenement.imageUrl" (valueChange)="formEvenement.imageUrl = $event"></app-photo-uploader>
  <label>{{ 'admin.ev.videoId' | traduire }}</label>
  <input type="text" [(ngModel)]="formEvenement.youtubeId" name="youtubeId" placeholder="Ex : E3KBT8hBSVM (dans l'URL youtube.com/watch?v=...)">

  <p class="confirmation" *ngIf="messageConfirmation">{{ messageConfirmation }}</p>

  <div class="boutons-form">
    <button type="submit">{{ idEnModification !== null ? ('admin.ev.enregistrerModifs' | traduire) : ('admin.ev.ajouterBtn' | traduire) }}</button>
    <button type="button" class="btn-annuler" *ngIf="idEnModification !== null" (click)="annulerModification()">{{ 'admin.ev.annuler' | traduire }}</button>
  </div>
</form>

<h3>{{ 'admin.ev.existants' | traduire }}</h3>

<div class="filtre-barre">
  <input type="text" [(ngModel)]="texteRecherche" [placeholder]="'🔍 ' + ('admin.ev.rechercherTitre' | traduire)">
  <select [(ngModel)]="filtreCategorie">
    <option value="">{{ 'admin.ev.toutesCategories' | traduire }}</option>
    <option value="Musique">{{ 'admin.ev.catMusique' | traduire }}</option>
    <option value="Théâtre">{{ 'admin.ev.catTheatre' | traduire }}</option>
    <option value="Danse">{{ 'admin.ev.catDanse' | traduire }}</option>
    <option value="Cinéma">{{ 'admin.ev.catCinema' | traduire }}</option>
  </select>
</div>

<table class="table-liste">
  <thead>
    <tr>
      <th>{{ 'admin.ev.colTitre' | traduire }}</th>
      <th>{{ 'admin.ev.categorie' | traduire }}</th>
      <th>{{ 'admin.ev.colDate' | traduire }}</th>
      <th>{{ 'admin.ev.colPrix' | traduire }}</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let evenement of evenementsFiltres">
      <td>{{ evenement.titre }}</td>
      <td>{{ evenement.categorie }}</td>
      <td>{{ evenement.dateEvent }}</td>
      <td>{{ evenement.prix }} TND</td>
      <td>
        <button class="btn-modifier" (click)="modifierEvenement(evenement)">{{ 'admin.ev.modifier' | traduire }}</button>
        <button class="btn-supprimer" (click)="supprimerEvenement(evenement)">{{ 'admin.ev.supprimer' | traduire }}</button>
      </td>
    </tr>
    <tr *ngIf="evenementsFiltres.length === 0">
      <td colspan="5" style="text-align:center; color:#888;">{{ 'admin.ev.aucunResultat' | traduire }}</td>
    </tr>
  </tbody>
</table>
